<template>
  <div class="cell comment-cell">
    <button type="button" @click.stop="$emit('open-card')">
      <template v-if="lastCommentInfo">
        <Avatar
          size="24"
          :name="lastCommentInfo.name"
          :pic="lastCommentInfo.avatar"
          class="comment-cell_avatar"
        />
        <div class="comment-cell_text text-ellipsis">
          {{ lastCommentInfo.text }}
        </div>
        <!--        <Badge color="light-blue" rounded>{{ unreadComments }}</Badge>-->
      </template>
      <template v-else>
        <Icon type="message" size="16" color="secondary" />
        {{ $t('Add public comments') }}
      </template>
    </button>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';
  // import Badge from '@/components/ui/Badge';
  import Avatar from '@/components/avatars/Avatar';

  export default {
    name: 'CommentsCell',
    components: {
      Icon,
      // Badge,
      Avatar,
    },
    props: {
      unreadComments: Number,
      commentsResolved: Boolean,
      comments: {
        type: [Number, String],
        default: null,
      },
      rowId: {
        type: [Number, String],
        default: null,
      },
      row: Object,
      lastComment: Array,
    },
    computed: {
      lastCommentInfo() {
        let comment = this.lastComment?.[0];
        if (comment) {
          return {
            avatar: comment.author.files_urls.avatar_thumbnail,
            name: comment.author.name,
            text: comment.text,
          };
        }
        return null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .comment-cell {
    button {
      gap: 6px;
      display: flex;
      align-items: center;
      color: $text-secondary;
      width: 100%;
    }

    &_text {
      margin-right: auto;
    }

    &_avatar {
      margin-top: -2px;
      height: 24px !important;
      width: 24px !important;
      min-width: 24px !important;
    }
  }
</style>
